import './SingleVideo.css';
import { useRef } from 'react';
import { canUseDOM, injectImageResolution } from '../../../utils';
import Video from '../../atoms/Video';
import React from 'react';
import ErrorBoundary from '../../atoms/ErrorBoundary/ErrorBoundary';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
var SingleVideo = function SingleVideo(_ref) {
  var imgSrc2 = _ref.imgSrc2,
    alt2 = _ref.alt2,
    video = _ref.video,
    hasYoutubeVideo = _ref.hasYoutubeVideo,
    title = _ref.title,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var imgLoadedEvent = function imgLoadedEvent() {
    if (canUseDOM) {
      var isHeaderGeneric = imageRef.current.closest('.header-generic--primary');
      if (isHeaderGeneric) {
        var animButton = isHeaderGeneric.getElementsByClassName('header-animation-trigger');
        if (animButton && animButton.length) animButton[0].click();
      }
    }
  };
  var imageRef = useRef();
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-detail-content--single-video-styles section-detail-content--single-video-styles-rtl"
  }, canUseDOM && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("picture", {
    className: 'styled-curved-image'
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    "data-header": "normal",
    srcSet: "".concat(injectImageResolution(imgSrc2, 700, 700))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(imgSrc2, 325, 325)),
    ref: imageRef,
    onLoad: imgLoadedEvent,
    alt: alt2,
    "aria-hidden": "true",
    "aria-label": alt2
  })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Video, {
    videoSrc: video,
    videoType: hasYoutubeVideo ? 'external' : 'media',
    structuredScript: true,
    buttonCenterAlignment: true,
    buttonFilled: true,
    click: function click(val) {
      val === 'Play' ? tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['playVideoTitleAnalytics'], params), title.value) : tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['stopVideoTitleAnalytics'], params), title.value);
    }
  })))));
};
var commonStyles = "c167hgq3";
export default SingleVideo;